// Uncontrolled checkbox component
import React, { FunctionComponent } from 'react';

import { css } from '@emotion/core';
import { mq } from '@helpers/breakpoints';
import { Box } from '@rebass/emotion';
import Colors from '@theme/colors';

interface CheckboxProps {
  onClick: () => void;
  label?: string;
  value: boolean | number;
  checked: boolean;
}

const check = css`
  ::after {
    background: ${Colors.science37};
    content: '';
    display: inline-block;
    height: 10px;
    left: 7px;
    width: 10px;
    position: absolute;
    top: 7px;
    border-radius: 50%;
  }
`;

const Checkbox: FunctionComponent<CheckboxProps> = ({ label, onClick, value, checked }) => {
  return (
    <Box
      css={mq({
        padding: ['0 16% 0 0', 'none'],
      })}
      onClick={onClick}
    >
      <input
        type="radio"
        data-index="0"
        value={value}
        css={css`
          height: 1px;
          opacity: 0;
          width: 1px;
        `}
      />
      <label
        className="radio-label"
        css={css`
          position: relative;
          ::before {
            border: 2px solid ${checked && value ? Colors.science37 : Colors.neutral75};
            content: '';
            display: 'inline-block';
            height: 20px;
            width: 20px;
            border-radius: 50%;
            position: absolute;
            color: ${Colors.neutral75};
            opacity: 0.6;
          }

          ${checked && value && check}
        `}
      >
        <span
          css={css`
            position: relative;
            left: 40px;
            color: ${Colors.neutral75};
            opacity: 0.6;
          `}
        >
          {label}
        </span>
      </label>
    </Box>
  );
};

export default Checkbox;
